export default __webpack_public_path__ + "static/SRF 1100 - Product Specifications & Technical Data-96c02f24e452f164419e095fd279fb9c.pdf";